export const ORIGINAL_INVOICE_SENT_VIA_KIVRA = 1
export const ORIGINAL_INVOICE_SENT_VIA_MAIL = 2
